import React from "react";
import { Carousel } from "react-bootstrap";
import { MdChevronRight, MdChevronLeft } from "react-icons/md";
import "./carousel.css";
import notfound from "../../../assets/images/marketplace/default.png";
import { URL_CONFIG } from "../../../_constants/Config/URL_CONFIG";

class CarouselList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 1,
      direction: null,
      nextIcon: <MdChevronRight size="25" />,
      prevIcon: <MdChevronLeft size="25" />,
      id: "",
    };
    this.onClickGoToWareHouseDetails =
      this.onClickGoToWareHouseDetails.bind(this);
  }

  componentDidMount() {
    this.setState({
      id: this.props.warehousecontent ? this.props.warehousecontent.id : "",
    });
  }

  componentDidUpdate(prev) {
    if (prev.warehousecontent !== this.props.warehousecontent)
      this.setState({
        id: this.props.warehousecontent ? this.props.warehousecontent.id : "",
      });
  }

  handleSelect = (selectedIndex, e) => {
    this.setState({
      index: selectedIndex,
      direction: e ? e.direction : "",
    });
  };
  onClickGoToWareHouseDetails() {
    let data = this.props.warehousecontent;
    if (this.state.id !== "") {
      let name = data
        ? data.name
            .toLowerCase()
            .replace(/[ `~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "-")
        : "";
      name = name + "-" + this.state.id;
      if (name !== undefined && name !== null && name !== "")
        window.open(
          URL_CONFIG.PROD_DOMAIN + "warehouse/" + data.warehouse_slug,
          "_blank"
        );
    }
    // this.props.history.push('/Warehouse/' + id);
  }

  onClick = (i) => {
    if (this.props.onClick) this.props.onClick(i);
  };

  render() {
    const { nextIcon, prevIcon } = this.state;
    return (
      <React.Fragment>
        {
          <div className="warehoseTiles mb-0">
            {this.props.sliderurl && this.props.sliderurl.length === 0 ? (
              <img
                onClick={() => this.onClickGoToWareHouseDetails()}
                className="d-block w-100"
                src={notfound}
                alt="First slide"
                height="340px"
                loading="lazy"
              />
            ) : this.props.sliderurl.length === 1 ? (
              <img
                onClick={() => this.onClick(0)}
                className="d-block w-100"
                src={this.props.sliderurl[0]}
                alt="First slide"
                height="340px"
                loading="lazy"
              />
            ) : (
              <Carousel
                className="warehouseList-carousel"
                nextIcon={nextIcon}
                prevIcon={prevIcon}
                index={this.state.index}
                direction={this.state.direction}
                onSelect={this.handleSelect}
              >
                {this.props.sliderurl &&
                  this.props.sliderurl.map((data, index) => (
                    <Carousel.Item
                      key={index}
                      onClick={() => this.onClick(index)}
                    >
                      <img
                        onClick={() => this.onClickGoToWareHouseDetails()}
                        className="d-block w-100"
                        src={data}
                        alt="First slide"
                        height="340px"
                        loading={index> 1 ?"lazy":'eager'}
                      />
                      {this.props.children && this.props.children[index]}
                    </Carousel.Item>
                  ))}
              </Carousel>
            )}
          </div>
        }
      </React.Fragment>
    );
  }
}

export default CarouselList;
